<div class="mat-dialog-container_custom" id="matdialogcontainer_custom">
	<div *ngIf="titleText!=''" class="modal_title_sec">
		<h2 class="title">{{titleText}}</h2>
	</div>
	<div *ngIf="icon==''" style="margin-bottom: 30px;">
	</div>
	<div *ngIf="icon=='success'" class="iconStyle">
		<svg class="svg_sucess_cen" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<defs>
				<linearGradient id="linear_suc_cen" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#5f0f7b" />
					<stop offset="33%" stop-color="#602775" />
					<stop offset="66%" stop-color="#c5191a" />
					<stop offset="100%" stop-color="#cc5414" />
				</linearGradient>
			</defs>
			<path stroke="url(#linear_suc_cen)" class="circle_sucess_cen"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke-linecap="round" stroke-linejoin="round" />
			<path stroke="url(#linear_suc_cen)" class="tick_sucess_cen" d="M7 12.5L10 15.5L17 8.5"
				stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	</div>
	<div *ngIf="icon=='error'" class="iconStyle">
		<svg class="svg_sucess_cen" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<defs>
				<linearGradient id="linear_error_cen" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#5f0f7b" />
					<stop offset="33%" stop-color="#602775" />
					<stop offset="66%" stop-color="#c5191a" />
					<stop offset="100%" stop-color="#cc5414" />
				</linearGradient>
			</defs>
			<path class="circle_error_cen" stroke="url(#linear_error_cen)"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke-linecap="round" stroke-linejoin="round" />
			<path d="M12 17.01L12.01 16.9989" class="error_round_cen" stroke="url(#linear_error_cen)" stroke-width="1.5"
				stroke-linecap="round" stroke-linejoin="round" />
			<path d="M12 7L12 13" class="tick_error_cen" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	</div>
	<div *ngIf="icon=='logout'" class="iconStyle">
		<svg class="svg_sucess_cen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 196.953 193.462">
			<g id="man" data-name="Group 9" transform="translate(-908.381 -1269.372)">
				<defs>
					<linearGradient id="linear_logout_cen" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" stop-color="#5f0f7b" />
						<stop offset="33%" stop-color="#602775" />
						<stop offset="66%" stop-color="#c5191a" />
						<stop offset="100%" stop-color="#cc5414" />
					</linearGradient>
					<linearGradient id="linear_logout_cen1" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" stop-color="#c5191a" />
						<stop offset="100%" stop-color="#cc5414" />
					</linearGradient>
				</defs>
				<path id="Path_4" class="man_svg_cen" fill="url(#linear_logout_cen)" data-name="Path 4"
					d="M970.339,1459.4c-26.276,0-56.786-2.215-78.105-10.614v0a3.063,3.063,0,0,1-1.782-1.9c-1.019-3.179,8.963-41.4,14.47-45.331l.349.489c7.725-6.164,41.169-21.17,52.482-26.086-4.467-8.052-14.163-27.267-16.1-31.113l-3.39-2.4a3,3,0,0,1-1.165-1.675,72.1,72.1,0,0,1-2.113-20.364,3.057,3.057,0,0,1,.89-2.2,3,3,0,0,1,1.083-.693c.347-.2.891-.537,1.4-.859.074-3.932.23-14.02-.027-18.14a3,3,0,0,1,.873-2.308c4.35-9.43,17.768-31.731,41.967-29.9,4.852-.525,33.519,2.323,42.68,31.113a2.965,2.965,0,0,1,.049,1.636c-.1,1.684-.052,9.682.063,17.405l2.371,1.185a3,3,0,0,1,1.643,2.987l-2,19.667a3,3,0,0,1-.751,1.7l-3.977,4.436c-1.719,4.3-10.513,25.662-18.048,32.654-2.058,3.219-14.368,10.908-22.135,10.23-.011,0-13.083-1.368-20.249-8.432-9.225,3.731-48.3,22.911-52.168,25.355a3,3,0,0,1-.246.2c-3.045,2.863-10.209,29.465-11.8,37.589,43.428,15.731,125.553,6.75,126.392,6.656a3,3,0,0,1,.67,5.962A524.422,524.422,0,0,1,970.339,1459.4Zm-5.284-82.77c4.754,4.669,14.222,6.5,16.491,6.707,5.447.475,14.433-5.4,16.376-7.219a3,3,0,0,1,.834-1.1c5.8-4.792,14.325-24.211,17.12-31.289a3,3,0,0,1,.557-.9l3.681-4.106,1.692-16.634-2.148-1.074a3,3,0,0,1-1.658-2.634c-.187-11.4-.276-16.862-.012-19.611-8.474-25.664-34.153-26.486-36.087-26.492a3,3,0,0,1-.826.043c-20.626-1.785-32.5,17.927-36.7,26.642.265,5.891-.025,18.862-.038,19.437a3,3,0,0,1-1.389,2.463c-.76.483-1.43.91-2.03,1.27a67.628,67.628,0,0,0,1.736,16.066l3.084,2.185a3,3,0,0,1,.949,1.106c8.221,16.443,16.715,32.589,17.692,34.017A2.6,2.6,0,0,1,965.054,1376.635Z"
					transform="translate(18 3.167)" />
				<path id="Path_5" class="collar_cen" data-name="Path 5" fill="url(#linear_logout_cen1)"
					d="M1024.554,1392.962s-19.981-10.99-24.31-13.321a3,3,0,1,1,2.845-5.283c4.338,2.336,24.357,13.346,24.357,13.346Z"
					transform="translate(18 3.167)" />
				<path class="arrow_hide_center" data-name="Path 6" fill="url(#linear_logout_cen1)"
					d="M1038.667,1387.333v21.333H987V1432h51.667v21.667L1081.333,1421l-42.667-33.667m0-6a6,6,0,0,1,3.718,1.29l42.667,33.667a6,6,0,0,1-.069,9.474l-42.667,32.667a6,6,0,0,1-9.647-4.764V1438H987a6,6,0,0,1-6-6v-23.333a6,6,0,0,1,6-6h45.667v-15.333a6,6,0,0,1,6-6Z"
					transform="translate(18 3.167)" />
			</g>
		</svg>
	</div>
	<div *ngIf="icon=='delete'" class="iconStyle">
		<svg xmlns="http://www.w3.org/2000/svg" class="svg_sucess_cen" viewBox="0 0 192 192">
			<defs>
				<linearGradient id="linear_del_cen" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#5f0f7b" />
					<stop offset="33%" stop-color="#602775" />
					<stop offset="66%" stop-color="#c5191a" />
					<stop offset="100%" stop-color="#cc5414" />
				</linearGradient>
			</defs>
			<g id="Group_14" data-name="Group 14" transform="translate(-1443 -1022)">
				<g id="Group_13" data-name="Group 13" transform="translate(1443 1022)">
					<g id="Group_4" data-name="Group 4">
						<g id="Ellipse_1" data-name="Ellipse 1" fill="none" stroke="#707070" stroke-width="6">
							<circle class="circle_del_center" cx="96" cy="96" stroke="url(#linear_del_cen)" r="93"
								fill="none" />
						</g>
					</g>
				</g>
				<g id="Group_15" class="del_box_cen" data-name="Group 15" transform="translate(-0.343 0.424)">
					<path id="Path_12" stroke="url(#linear_del_cen)" data-name="Path 12"
						d="M1497,1101v61.027s4.521,8.137,11.753,10.4H1551.7s8.815-3.39,13.109-10.4c.226.226,0-61.027,0-61.027"
						transform="translate(9.452 3)" fill="none" stroke-linecap="round" stroke-linejoin="round"
						stroke-width="7" />
					<line id="Line_1" stroke="#602775" data-name="Line 1" y2="46.123"
						transform="translate(1523.178 1114)" fill="none" stroke-linecap="round" stroke-width="6" />
					<line id="Line_2" stroke="#c5191a" data-name="Line 2" y2="46.123"
						transform="translate(1540.406 1114)" fill="none" stroke-linecap="round" stroke-width="6" />
					<line id="Line_3" stroke="#cc5414" data-name="Line 3" y2="46.123"
						transform="translate(1557.635 1114)" fill="none" stroke-linecap="round" stroke-width="6" />
					<path id="Path_13" class="del_cap_cen" stroke="url(#linear_del_cen)" data-name="Path 13"
						d="M1482.75,1086.76v-13.336s5.2-5.425,8.589-5.425c-.452.226,74.136,0,74.136,0a17.32,17.32,0,0,1,8.589,5.425c-.678.226,0,13.336,0,13.336Z"
						transform="translate(10.593 7.069)" fill="none" stroke-linecap="round" stroke-linejoin="round"
						stroke-width="7" />
					<path id="Path_14" class="del_cap_cen" stroke="#c5191a" data-name="Path 14"
						d="M1525.5,1067.237v-9.493s2.034-5.2,7.007-4.747c0,.226,4.295-.226,6.555,4.747v9.493Z"
						transform="translate(6.719 7.606)" fill="none" stroke-linecap="round" stroke-linejoin="round"
						stroke-width="6" />
				</g>
			</g>
		</svg>
	</div>
	<div *ngIf="icon=='changepassword'" class="iconStyle">
		<svg xmlns="http://www.w3.org/2000/svg" class="svg_sucess_cen" viewBox="0 0 138.23 138.264">
			<defs>
				<linearGradient id="linear_pass_cen" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#5f0f7b" />
					<stop offset="33%" stop-color="#602775" />
					<stop offset="66%" stop-color="#c5191a" />
					<stop offset="100%" stop-color="#cc5414" />
				</linearGradient>
				<linearGradient id="linear_pass_cen2" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#c5191a" />
					<stop offset="100%" stop-color="#cc5414" />
				</linearGradient>
				<linearGradient id="linear_pass_cen1" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#5f0f7b" />
					<stop offset="50%" stop-color="#602775" />
					<stop offset="100%" stop-color="#c5191a" />
				</linearGradient>
			</defs>
			<g id="Group_2" data-name="Group 2" transform="translate(2 2.002)">
				<g id="password-pass_tni_0013" class="center_svg_cen" transform="translate(41.08 57.815)">
					<path id="Path_15" stroke="url(#linear_pass_cen1)" data-name="Path 15"
						d="M53.517,29.226V12.636C53.517,8.972,51,6,47.9,6H8.613C5.514,6,3,8.972,3,12.636V32.544c0,3.665,2.514,6.636,5.613,6.636H28.258"
						transform="translate(-3 -6)" fill="none" stroke-linecap="round" stroke-linejoin="round"
						stroke-width="6" />
					<path id="Path_16" stroke="url(#linear_pass_cen2)" class="right_tickPass_cen" data-name="Path 16"
						d="M14.5,21.437l5.613,5.613,15.215-15.5" transform="translate(17.774 18.76)" fill="none"
						stroke-linecap="round" stroke-linejoin="round" stroke-width="6" />
					<path id="Path_17" data-name="Path 17" d="M12,11.03l.028-.03" transform="translate(13.258 5.589)"
						fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" />
					<path id="Path_18" data-name="Path 18" d="M16,11.03l.028-.03" transform="translate(20.484 5.589)"
						fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" />
					<path id="Path_19" data-name="Path 19" d="M8,11.03,8.028,11" transform="translate(6.033 5.589)"
						fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" />
				</g>
				<path id="Path_20" stroke="url(#linear_pass_cen1)" class="center_svg_cen" data-name="Path 20"
					d="M1530,723.751V709.558s4.72-7.921,12.044-7.758,9.313,3.14,12.776,7.758c-.577,0,0,14.193,0,14.193Z"
					transform="translate(-1476.072 -665.954)" fill="none" stroke-linejoin="round" stroke-width="6" />
				<g id="Group_1" data-name="Group 1">
					<path id="Path_24" stroke="url(#linear_pass_cen)" class="left_passarrow_cen" data-name="Path 24"
						d="M1613.275,705.309l.979,15.57s-17.977-18.178-46.231-17.148c-9.734-.23-17.212,2.292-26.281,5.837-7.825,3.158-14.551,8.146-21.814,15.755-9.155,9.589-16.966,23.979-16.966,44.436-.261-.265-.183,17.371,6.92,31.314"
						transform="translate(-1501.889 -702.689)" fill="none" stroke-linecap="round"
						stroke-linejoin="round" stroke-width="4" />
					<path id="Path_24-2" stroke="url(#linear_pass_cen)" class="right_passarrow_cen" data-name="Path 24"
						d="M1503.869,799.453l-.979-15.57s17.977,18.178,46.231,17.148c9.734.23,17.212-2.292,26.281-5.837,7.825-3.158,14.551-8.146,21.814-15.755,9.155-9.589,16.966-23.979,16.966-44.436.261.265.183-17.371-6.92-31.314"
						transform="translate(-1481.024 -667.813)" fill="none" stroke-linecap="round"
						stroke-linejoin="round" stroke-width="4" />
				</g>
			</g>
		</svg>
	</div>

	<mat-dialog-content style="text-align: center;" *ngIf="titleText!='PII Agent'">
		<p [innerHTML]="message">
			<!-- {{message}} -->
		</p>
	</mat-dialog-content>
	<mat-dialog-actions align="center" *ngIf="titleText!='PII Agent'">
		<span *ngIf="MessageBoxType=='confirmation'">
			<button type="button" class="model_ok_btn" (click)="onConfirmClick()" tabindex="1">
				<span class="modal_ok_btn_txt">{{confirmButtonText}}</span>
			</button>
			<button type="button" class="model_cancle_btn" tabindex="-1" (click)="dialogRef.close()">
				<span class="modal_can_btn_txt">{{cancelButtonText}}</span>
			</button>
		</span>
		<span *ngIf="MessageBoxType=='ok'">
			<button type="button" class="model_ok_btn" (click)="onConfirmClick()" tabindex="1">
				<span class="modal_ok_btn_txt">{{confirmButtonText}}</span>
			</button>
		</span>
		<span *ngIf="MessageBoxType=='question'">
			<button type="button" class="model_ok_btn" (click)="onConfirmClick()" tabindex="1">
				<span class="modal_ok_btn_txt">Yes</span>
			</button>
			<button type="button" class="model_cancle_btn" tabindex="-1" (click)="dialogRef.close()">
				<span class="modal_can_btn_txt">No</span>
			</button>
		</span>
		<span *ngIf="MessageBoxType=='progress-bar'">
			<div class="load">
				<div class="whirly-loader"> </div>
			</div>
			<button type="button" class="model_ok_btn" (click)="onConfirmClick()" tabindex="1">
				<span class="modal_ok_btn_txt">{{confirmButtonText}}</span>
			</button>
			<button type="button" class="model_cancle_btn" tabindex="-1" (click)="dialogRef.close()">
				<span class="modal_can_btn_txt">{{cancelButtonText}}</span>
			</button>
		</span>

		<span *ngIf="showRedirectButton" class="redirectbuttonSpan">
			<a [routerLink]="[redirectButtonUrl]" mat-raised-button (click)="redirectButtonClicked()">
				{{redirectButtonText}}
			</a>
		</span>

	</mat-dialog-actions>
	<mat-dialog-content *ngIf="titleText=='PII Agent'">
		<p [innerHTML]="message"
			[ngClass]="titleText=='PII Agent'?piiresponsestatus?'piiresponsecolor piidialogtext':'piidialogtext':'dialogtext'">
		</p>
		<!-- <p [innerHTML]="message">
		</p> -->
		<p [innerHTML]="Piiresponsemessage" *ngIf="ShowPiiresult" style>
		</p>
		<a (click)="showpiidata()" *ngIf="ShowPiiresult" style="text-align: left;">View</a>
		<!-- <span *ngIf="titleText=='PII Agent'&&piiresponsestatus">
			<button type="button" class="model_ok_btn" (click)="showpiidata()" tabindex="1" style="margin: left;">
				<span class="modal_ok_btn_txt">View PII Information</span>
			</button>
		</span> -->
	</mat-dialog-content>
	<mat-dialog-actions align="center" *ngIf="titleText=='PII Agent'">
		<span *ngIf ="! showwisdomnext">
			<button type="button" class="model_ok_btn" (click)="onConfirmClick()" tabindex="1">
				<span class="modal_ok_btn_txt">{{confirmButtonText}}</span>
			</button>
		</span>
	</mat-dialog-actions>
	<mat-dialog-content *ngIf="showwisdomnext&&wisdomnetresponse!=''">
		<p [innerHTML]="wisdomnetresponse"></p>
	</mat-dialog-content>
	<mat-dialog-actions align="center" *ngIf="showwisdomnext&&wisdomnetresponse!=''">
		<span>
			<button type="button" class="model_ok_btn" tabindex="1" (click)="closeresponse()" >
				<span class="modal_ok_btn_txt">{{responseButtonText}}</span>
			</button>
		</span>
	</mat-dialog-actions>
</div>